import React from 'react';
import './airport.css';
import { FaCarSide, FaClock, FaUserTie, FaTags } from "react-icons/fa";
import { Link } from "react-router-dom";



function AirportTour() {
  return (

    <section className="airport-tour" aria-labelledby="airport-tour-heading">
      <div className="airport-container">
        {/* Hero Section */}
        <div className="airport-hero">
          <div className="hero-content">
            <h1 id="airport-tour-heading" className="hero-title">
              Premium Airport Transfer & Tour Services
            </h1>
            <p className="hero-description">
              Experience seamless airport transfers and exclusive tours with our premium service. 
              Professional drivers, luxury vehicles, and punctual service guaranteed.
            </p>
            <div className="hero-buttons">
              <Link to="/bookings">
              <button className="cta-button primary">Book Now</button></Link>
         
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="/retionz airport.png" 
              alt="Luxury airport transfer vehicle and professional driver service"
              loading="eager"
              width="600"
              height="400"
            />
          </div>
        </div>

        {/* Features Section */}


<div className="features-section">
  <h2 className="features-title">Why Choose Our Airport Services</h2>
  <div className="features-grid">

    <div className="feature-card">
      <div className="feature-icon">
        <FaCarSide />
      </div>
      <h3>Premium Vehicles</h3>
      <p>Luxury cars maintained to highest standards for your comfort and safety</p>
    </div>

    <div className="feature-card">
      <div className="feature-icon">
        <FaClock />
      </div>
      <h3>Punctual Service</h3>
      <p>On-time guaranteed with real-time flight tracking</p>
    </div>

    <div className="feature-card">
      <div className="feature-icon">
        <FaUserTie />
      </div>
      <h3>Professional Drivers</h3>
      <p>Experienced, licensed, and courteous chauffeurs</p>
    </div>

    <div className="feature-card">
      <div className="feature-icon">
        <FaTags />
      </div>
      <h3>Best Prices</h3>
      <p>Competitive rates with no hidden charges</p>
    </div>

  </div>
</div>


        {/* Services Section */}
        <div className="services-section">
          <div className="services-content">
            <h2>Our Services</h2>
            <ul className="services-list">
              <li>Airport Pickup & Drop-off</li>
              <li>Corporate Transfers</li>
              <li>City Tours</li>
              <li>VIP Services</li>
              <li>Luggage Assistance</li>
              <li>24/7 Customer Support</li>
            </ul>
          </div>
          <div className="services-image">
            <img 
              src="/airport.jpg" 
              alt="Airport transfer services including pickup, drop-off, and city tours"
              loading="lazy"
              width="500"
              height="350"
            />
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <h2>Ready for Your Journey?</h2>
          <p>Book your airport transfer now and travel with confidence</p>
             <Link to="/bookings">
          <button className="cta-button large">Book Your Transfer</button></Link>
        </div>
      </div>
    </section>
  );
}

export default AirportTour;